import { render, staticRenderFns } from "./AcessoEmpresa.vue?vue&type=template&id=28fad46c&"
import script from "./AcessoEmpresa.vue?vue&type=script&lang=js&"
export * from "./AcessoEmpresa.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/acessoEmpresa.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports